import {Checkbox, FormControlLabel, Grid2 as Grid, Typography, useMediaQuery, useTheme} from "@mui/material";
import React from "react";
import FormGroup from "./FormGroup";
import {MasterReport} from "../../data/reports";
import {paramOptions} from "../../data/options";
import {availableParameter} from "../../data/parameter";
import FormCheckbox from "./FormCheckbox";
import FormSelect from "./FormSelect";
import FormAggregation from "./FormAggregation";
import FormInput from "./FormInput";

interface MasterReportParametersProps {
  values: Record<string, any>;
  aggregations: Record<string, boolean>;
  changeForm: (name: string, value: any) => void;
  changeAggregation: (name: string, value: boolean) => void;
}

export default function MasterReportParameters({
  values, aggregations, changeForm, changeAggregation
}: MasterReportParametersProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const report: MasterReport = values.report && values.report.group?.id;
  const paramItems = paramOptions[report];
  const availableParameters = availableParameter[report];

  return <FormGroup expanded={!isMobile} title={"Report parameters"}>
    <Grid size={12} container>
      <Grid size={6}><Typography>Filter</Typography></Grid>
      <Grid size={6} textAlign="right"><Typography>Show column</Typography></Grid>
    </Grid>

    {availableParameters.data_type && <FormSelect
      name="data_type"
      label="Data Type"
      items={paramItems.data_type}
      values={values}
      onChange={changeForm}
      size={11}
      multiple />}

    {availableParameters.yop && <FormAggregation
      name={"yop"}
      label="include year of publication column in report"
      values={aggregations}
      onChange={changeAggregation}>
      <FormInput
        name="yop"
        label={"Year of publication"}
        values={values}
        onChange={changeForm}
        size={11} />
    </FormAggregation>}

    {availableParameters.access_type && <FormAggregation
      name="access_type"
      label="include access type column in report"
      values={aggregations}
      onChange={changeAggregation}>
      <FormSelect
        name="access_type"
        label="Access Type"
        items={paramItems.access_type}
        values={values}
        onChange={changeForm}
        size={11}
        multiple />
    </FormAggregation>}

    {availableParameters.access_method && <FormAggregation
      name="access_method"
      label="include access method column in report"
      values={aggregations}
      onChange={changeAggregation}>
      <FormSelect
        name="access_method"
        label="Access Method"
        items={paramItems.access_method}
        values={values}
        onChange={changeForm}
        size={11}
        multiple />
    </FormAggregation>}

    <FormSelect
      name="metric_type"
      label={"Metric Type"}
      items={paramItems["metric_type"]}
      values={values}
      onChange={changeForm}
      size={11}
      multiple />

    {report === "IR" && [
      <FormCheckbox
        key="ipd"
        name={"include_parent_details"}
        label={"Include Parent Details"}
        onChange={changeForm}
        values={values} />,
      <FormCheckbox
        key="icd"
        name={"include_component_details"}
        label={"Include Component Details"}
        onChange={changeForm}
        values={values} />,
      <FormCheckbox
        key="a"
        name={"authors"}
        label={"Authors"}
        onChange={changeAggregation}
        values={aggregations} />,
      <FormCheckbox
        key="pd"
        name={"publication_date"}
        label={"Publication Date"}
        onChange={changeAggregation}
        values={aggregations} />,
      <FormCheckbox
        key="av"
        name={"article_version"}
        label={"Article Version"}
        onChange={changeAggregation}
        values={aggregations} />
    ]}

    <Grid size={12}>
      <FormControlLabel control={<Checkbox
        data-testid="granularity"
        checked={values.granularity !== "Month"}
        onChange={e => changeForm("granularity", e.target.checked ? "Total" : "Month")}
      />} label={"Exclude monthly details"} />
    </Grid>
  </FormGroup>;

}
